export const ticketsUrl = "tickets"
export const vouchersUrl = "vouchers"

export const isTicketsPage = (): boolean => window.location.pathname.split("/").includes(ticketsUrl)
export const isVouchersPage = (): boolean => window.location.pathname.split("/").includes(vouchersUrl)